<template>
    <div>
        <el-dialog title="Attached Devices" :visible.sync="dialogVisible" @open="openTopo" @close="$emit('closeTopo')">
            <div class="topo">
                <div v-if="$G_DEVICE_CFG.area!='TRUE'">
                    <h4 class="topo-title">Router</h4>
                    <h5>Online Subrouter lists({{subRouterLists.length}})</h5>
                    <div class="topo-header row">
                        <div class="col-xs-6 topo-router row">
                            <div class="col-xs-4 router-icon">
                                <img src="@/assets/img/home/Group_34.png">
                            </div>
                            <div class="col-xs-8 main-router">
                                <p class="wifi-title">Main Router</p>
                                <p class="wifi-info">
                                    <i class="glyphicon glyphicon-arrow-up upload-color" aria-hidden="true"></i> {{byteToKbOrMb(manUpSpeed)}}
                                    <i class="glyphicon glyphicon-arrow-down download-color" aria-hidden="true"></i> {{byteToKbOrMb(manDownSpeed)}}
                                </p>
                                
                                <p class="wifi-info">{{mainRouter.ip}}</p>
                                <p class="wifi-info">{{mainRouter.Mac}}</p>
                            </div>
                        </div>
                        <div class="col-xs-6 topo-router">
                            <el-carousel height="200px">
                                <el-carousel-item v-for="(cDevice,index) in subRouterLists" :key="cDevice.Mac" :interval="10000">
                                    <div class="topo-devices row">
                                        <div class="col-xs-4 router-icon">
                                            <img src="@/assets/img/home/Group_34.png">
                                        </div>
                                        <div class="col-xs-8">
                                            <p class="wifi-title">Subrouter-{{index + 1}}</p>
                                            <p class="wifi-info">
                                                {{setSubAccessType(cDevice.ChildRouterAccessType)}} 
                                                from 
                                                {{cDevice.subAccessRouterName}}
                                            </p>
                                            <p class="wifi-info">
                                                <i class="glyphicon glyphicon-arrow-up upload-color" aria-hidden="true"></i> {{byteToKbOrMb(cDevice.DownSpeed)}}
                                                <i class="glyphicon glyphicon-arrow-down download-color" aria-hidden="true"></i> {{byteToKbOrMb(cDevice.UpSpeed)}}
                                            </p>
                                            <p class="wifi-info" v-if="typeof cDevice.LinkSpeed !== 'undefined' ">Link Speed: {{cDevice.LinkSpeed}}</p>
                                            <p class="wifi-info" v-if="typeof cDevice.wlanauth !== 'undefined' && cDevice.ChildRouterAccessType !== '1'">
                                                Security: {{cDevice.wlanauth}}
                                            </p>
                                            <p class="wifi-info" v-if="typeof cDevice.dbm !== 'undefined' && cDevice.ChildRouterAccessType !== '1'">
                                                Rssi: {{cDevice.dbm}} dbm
                                            </p>
                                            <p class="wifi-info">{{cDevice.ip}}</p>
                                            <p class="wifi-info">{{cDevice.Mac}}</p>
                                            <p class="wifi-info">{{cDevice.FWVersion}}</p>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>
                <h4 class="topo-title">Terminal Devices</h4>
                <div class="topo-main">
                    <h5>Online device lists({{childDevicelist.length}})</h5>
                    <div class="topo-devices row" v-for="cDevice in childDevicelist" :key="cDevice.Mac">
                        <div class="col-xs-4 dev-icon">
                            <img v-if="cDevice.DevType === '1'" src="@/assets/img/home/ic_phone_black.png">
                            <img v-else-if="cDevice.DevType === '2'" src="@/assets/img/home/ic_ipad_black.png">
                            <img v-else-if="cDevice.DevType === '3'" src="@/assets/img/home/ic_computer_black.png">
                            <img v-else-if="cDevice.DevType === '0' &&  cDevice.AccessType === '1' "
                                src="@/assets/img/home/ic_wired_black.png">
                            <img v-else-if="cDevice.DevType === '0' &&  cDevice.AccessType != '1' "
                                src="@/assets/img/home/ic_wifi_black.png">
                            <img v-else src="@/assets/img/home/ic_computer_black.png">
                        </div>
                        <div class="col-xs-8">
                            <p class="wifi-title">{{cDevice.Name}}</p>
                            <p class="wifi-info" v-if="$G_DEVICE_CFG.area!='TRUE'">
                                {{setAccessType(cDevice.AccessType)}} 
                                from 
                                {{cDevice.accessRouterName}}
                            </p>
                            <p class="wifi-info" v-if="$G_DEVICE_CFG.area==='TRUE'">
                                {{setAccessType(cDevice.AccessType)}}
                            </p>
                            <p class="wifi-info">
                                <i class="glyphicon glyphicon-arrow-up upload-color" aria-hidden="true"></i> {{byteToKbOrMb(cDevice.DownSpeed)}}
                                <i class="glyphicon glyphicon-arrow-down download-color" aria-hidden="true"></i> {{byteToKbOrMb(cDevice.UpSpeed)}}
                            </p>
                            <p class="wifi-info" v-if="typeof cDevice.LinkSpeed !== 'undefined' ">Link Speed: {{cDevice.LinkSpeed}}</p>
                            <p class="wifi-info" v-if="typeof cDevice.wlanauth !== 'undefined' && cDevice.AccessType !== '1'">
                                Security: {{cDevice.wlanauth}}
                            </p>
                            <p class="wifi-info" v-if="typeof cDevice.dbm !== 'undefined' && cDevice.AccessType !== '1'">
                                Rssi: {{cDevice.dbm}} dbm
                            </p>
                            <p class="wifi-info">{{cDevice.ip}}</p>
                            <p class="wifi-info">{{cDevice.Mac}}</p>
                            <p class="wifi-info">{{cDevice.AccessTime}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// import testTopoD from '@/test/topo_data.json'
export default {
    props:['isShow','topoData'],
    data() {
        return {
            clientNum: 0,
            isLoad:false,
            subRouterLists:[],
            mainRouter:{},
            childDevicelist:[],
            dialogVisible:false,
            manUpSpeed:0,
            manDownSpeed:0
        }
    },
    watch: {
        isShow(newValue, oldValue) {
            this.dialogVisible = newValue
        }
    },
    methods: {
        openTopo(){
            this.childDevicelist = []
            this.subRouterLists = []
            this.getData(this.topoData)
            this.intervalGetData()
        },
        getData(data) {
            this.mainRouter = data.MainRouter
            let _cDevList = []
            let _subList = []
            data.MainBaseInfo.forEach((e)=>{
                    e.accessRouterName = 'Main Router'
                    if(Object.keys(e).length != 0) _cDevList.push(e)
            })
            
            if(data.ChildRouter)
            {
                data.ChildRouter.forEach((e,subIndex) => {
                    if(Object.keys(e).length != 0)
                    {
                        _subList.push(e)
                        e.ChildBaseInfo.forEach((c)=>{
                            if(Object.keys(c).length != 0)
                            {
                                let found = false
                                for (let index = 0; index < _cDevList.length; index++) {
                                    if(_cDevList[index].Mac === c.Mac) 
                                    {
                                        _cDevList[index] = c
                                        _cDevList[index].accessRouterName = `SubRouter-${subIndex + 1}`
                                        found = true
                                        break
                                    }
                                }
                                c.accessRouterName = `SubRouter-${subIndex + 1}`
                                if(!found) _cDevList.push(c)
                            }
                            
                        })
                    }
                })
            }
            
            _cDevList = _cDevList.filter(e => {
                for (let index = 0; index < _subList.length; index++) {
                    if(_subList[index].Mac === e.Mac) return false
                }
                return true
            })
            data.MainRouter.routerName = 'Main Router'

            this.manUpSpeed = 0
            this.manDownSpeed = 0
            _subList.forEach((e,i) => {
                e.routerName = `SubRouter-${i + 1}`
                this.manUpSpeed += parseInt(e.UpSpeed) 
                this.manDownSpeed += parseInt(e.DownSpeed)
            })
            this.manUpSpeed = parseInt(this.mainRouter.UpSpeed) > this.manDownSpeed
                                ? this.mainRouter.UpSpeed : this.manDownSpeed
            this.manDownSpeed = parseInt(this.mainRouter.DownSpeed) > this.manUpSpeed 
                                ? this.mainRouter.DownSpeed : this.manUpSpeed

            const routerList = _subList.concat([data.MainRouter])
            _subList.map(e => {
                routerList.forEach(c => {
                    // 子路由上行连接方式 默认初始为 Main Router
                    if(!e.subAccessRouterName )
                        e.subAccessRouterName = 'Main Router'

                    // 根据MAC查找实际的上行
                    if(e.nexthopMAC && findFormRoter(e.nexthopMAC,c.Mac))
                        e.subAccessRouterName = c.routerName
                    
                })
            })
            
            this.childDevicelist = _cDevList;
            this.subRouterLists = _subList;
            let getAllTimes = new Date().getTime()/1000;

            this.childDevicelist.map(item=>{
                item.AccessTime = this.formatTime(getAllTimes-item.AccessTime)
            })
        },
        intervalGetData(){
            if(!this.dialogVisible) return
            setTimeout(()=>{
                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"GET_SUBDEV_INFO",
                })
                .then((response)=>{
                    this.childDevicelist = []
                    this.subRouterLists = []
                    this.getData(response.data.subDevInfo)
                    // this.getData(testTopoD.subDevInfo)
                })
                this.intervalGetData()
            },10000)
        },
        setAccessType(type){
            let text = 'unknow'
            switch (type) {
                case '1':
                    text = 'Wired access'
                    break;
                case '2':
                    text = '2.4G access'
                    break;
                case '3':
                    text = 'GUEST access'
                    break;
                case '4':
                    text = '5G access'
                    break;
                default:
                    break;
            }
            return text;
        },
        setSubAccessType(type){
            let text = 'unknow'
            switch (type) {
                case '1':
                    text = 'Wired access'
                    break;
                case '2':
                    text = '2.4G access'
                    break;
                case '3':
                    text = '5G access'
                    break;
                default:
                    break;
            }
            return text;
        },
        byteToKbOrMb(byte){
            byte = parseInt(byte) * 8
            const k = 1024
            const m = 1048576
            let speed = 0.00
            if(byte > m)
            {
                    speed = (byte / m).toFixed(1)
                    return `${speed} Mbps`
            }
            else if(byte > k && byte < m)
            {
                speed = (byte / k).toFixed(1)
                return `${speed} Kbps`
            }
            else if(byte > 0 && byte < k)
            {
                return `${byte} bps`
            }
            else
            {
                return '0.0 bps'
            }
        },
        formatTime(length){
            let days=0,hour = 0,minute = 0,seconds=0;
            seconds = parseInt(length);
            if(seconds > 60) {
                minute = parseInt(seconds / 60);
                seconds = parseInt(seconds % 60);
                if(minute > 60) {
                    hour = parseInt(minute / 60);
                    minute = parseInt(minute % 60);
                } 
                if(hour>24){
                    days = parseInt(hour / 24);
                    hour = parseInt(hour % 24);
                }  
            }
            seconds = seconds<10?'0'+seconds:seconds
            minute=minute<10?'0'+minute:minute;
            hour = hour<10?'0'+hour:hour;
            if(days==0){
                return hour+'h '+minute+'min '+seconds+'s' 
            }else{
                return days+'day '+hour+'h '+minute+'min '+seconds+'s' 
            }
               
        }
    },
}

/**
 * 根据 MAC查找子路连接的上行路由
 */
function findFormRoter(toMac,formMac) {
    const intToMac = parseInt('0x'+ toMac.split(':').join(''))
    const intFormMac = parseInt('0x'+ formMac.split(':').join(''))

    return ((intFormMac + 1) === intToMac || (intFormMac + 6) === intToMac) 
}
</script>

<style scoped>
.wifi-title{
    font-weight: bold;
}
.wifi-title,.wifi-info{
    margin: 5px 0;
}
.main-router {
    margin-top: 25px;
}
.router-icon,.dev-icon{
    text-align: center;
    height: 150px;
}
.router-icon>img{
    margin-top: 37.5px;
    width: 35px;
    height: 35px;
}
.dev-icon>img{
    margin-top: 30px;
    width: 50px;
    height: 50px;
}
</style>